import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		min-height: calc(100vh - 90px);
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;

		section {
			padding: 1em;
			flex: 1 1 auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			position: relative;

			.backHistory {
				position: absolute;
				top: 1em;
				left: 0;
				background: none;
				border: none;
				outline: none;
			}

			.block-qrcode {
				width: 100%;
				max-width: 308px;

				header {
					display: flex;
					flex-direction: column;
					align-items: center;

					.animal {
						display: flex;
						align-items: center;
						column-gap: 5px;

						img {
							width: 40px;
							height: 35px;
						}

						p {
							text-transform: uppercase;
							font-size: 1.125em;
							font-weight: 600;
						}
					}

					.info-cupom {
						display: flex;
						flex-direction: column;
						align-items: center;

						.cupom-header {
							font-size: 0.875em;
							margin: 0;
						}

						.cupom-number {
							font-size: 1.75em;
							font-weight: bold;
							margin: 5px 0;
						}

						.cupom-footer {
							font-size: 0.875em;
							width: 240px;
							text-align: center;
							margin: 0;
						}
					}
				}

				.qrcode {
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-top: 2.5em;
					margin-bottom: 1em;

					svg {
						background-color: #fff;
						padding: 15px;
						box-shadow: 0px 0px 8px 2px rgb(0 0 0 / 14%);
						margin: 5px;
					}
				}

				.form {
					display: flex;
					flex-direction: column;
					align-items: center;

					label {
						width: 100%;
						max-width: 100%;
						display: flex;
						flex-direction: column-reverse;

						input {
							width: 100%;
							max-width: 100%;
							height: 40px;
							border: 0;
							border-bottom: 1px solid #333;
							text-align: center;
							margin-bottom: 1.5em;
						}

						span.require {
							display: block;
							margin: 0 auto;
							color: tomato;
							font-size: 14px;
							padding-top: 2px;
						}
					}

					button {
						min-width: 218px;
						width: 100%;
						max-width: 218px;
						text-transform: inherit;
						font-weight: bold;
					}
				}
			}
		}

		.block-message {
			&__text {
				font-size: 1em;
				text-align: center;

				span {
					cursor: pointer;
					font-weight: bold;
					/* text-transform: uppercase; */
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		flex-direction: row;
		height: 100%;

		aside {
			flex-basis: 40%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: flex-end;

			img {
				max-height: 100%;
			}
		}

		section {
			flex-basis: 60%;
			padding: 0;
			/* background-image: url(${require("@/assets/img/labyes.png")
				.default});
			background-repeat: no-repeat;
			background-position: right bottom; */

			.backHistory {
				display: none;
			}
		}
	}
`;
